import React from "react";
import { useState, useEffect } from 'react';

import '../../index.css';

const API_URL = process.env.REACT_APP_API_URL || "/api";

const GwCommands = ({
    serial,
    data,
    mqttReq
}) => {
    const [versionState, setVersionState] = useState('')
    const handleVersionChange = (event) => { setVersionState(event.target.value) }
    const [rssiValue, setRssiValue] = useState(-1);

    function ledoff() {
        mqttReq(serial, '/cmdledoff')
    }

    function ledon() {
        mqttReq(serial, '/cmdledon')
    }

    function tunnel() {
        mqttReq(serial, '/cmdtunnel')
    }

    function rssi() {
        mqttReq(serial, '/rssimqttreq')
    }

    function reboot() {
        mqttReq(serial, '/cmdrebootapp')
    }

    function rebootsquid() {
        mqttReq(serial, '/cmdrebootsquid')
    }

    function updatesquid() {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ serial: serial, version: versionState })
        };
        fetch(API_URL + "/cmdupdate", requestOptions);
    }

    useEffect(() => {
        if ((data !== null) && (data !== undefined))
            setRssiValue(data?.rssi)
    }, [data]);

    return (
        <>
            <input type="text" value={versionState} onChange={handleVersionChange} />
            <button onClick={updatesquid}>update</button>
            <br />
            <button onClick={reboot}>Riavvia</button>

            <br /><br />
            
            <button onClick={rssi}>rssi</button>
            <p style={{ border: '1px solid black', display: 'inline-block', padding: '2px' }}>{rssiValue}</p>
            <br />
            <button onClick={ledoff}>LED off</button>
            <button onClick={ledon}>LED on</button>
            <button onClick={tunnel}>Tunnel</button>
            <br />
            <button onClick={rebootsquid}>Reboot Squid (HW)</button>
        </>
    );
};

export default GwCommands;
